export default {
  bankCard: '/courier/api/v2/cityBankCard',
  checkBankCard: '/courier/api/v3/check/cash/amount',
  // bindBankCard: '/courier/api/v2/bind/cash/account',
  addCourierBankCard: '/courier/api/v3/addCourierBankCard',
  delCourierBankCard: '/courier/api/v3/delCourierBankCard'
}
